module.exports = __webpack_public_path__ + "ed82e44342f15a5f9621ead31f3256a5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/owl-item-types/floor_items.png
// module id = 1726
// module chunks = 0